import React from "react";
import { CloudPremisePluginMenu } from "@cloudpremise/portal_core";

// @mui icons
import Icon from "@mui/material/Icon";

const menus = (): CloudPremisePluginMenu[] => {
    return [
        {
            type: "menu_item",
            name: "Firestore",
            key: "firestore",
            icon: <Icon fontSize="medium">local_shipping_outlined</Icon>,
            route: "/firebase/firestore",
            noCollapse: false,
            privacy: "private",
        },
    ];
};

export default menus;